<template>
  <OffersCarouselShimmer v-if="isLoading" />
  <section v-else class="w-full shrink-0 space-y-3">
    <slot />
    <OffersCarousel
      :offers="offers"
      :current-special-offer="currentSpecialOffer"
      :source="source"
      :cashback-click-source="cashbackClickSource"
      @onCashbackClick="emit('onCashbackClick')"
    />
  </section>
</template>

<script setup lang="ts">
  import type { specialOffers } from 'shared';

  import type { hotOffersTypes } from '@/entities/hot-offers';

  import type { analyticsEventsLib } from '@/shared/lib';

  import OffersCarouselShimmer from './OffersCarouselShimmer.vue';
  import OffersCarousel from './OffersCarousel.vue';

  defineProps<{
    isLoading: boolean;
    offers: hotOffersTypes.MappedHotOffer[];
    currentSpecialOffer?: specialOffers.Special;
    source?: string;
    cashbackClickSource: analyticsEventsLib.config.SearchResultCardCashbackPriceClickSource;
  }>();

  const emit = defineEmits<{
    onCashbackClick: [];
  }>();
</script>
